window.addEventListener('unhandledrejection', (event) => {
  if (__PLATFORM__ !== 'web') return;
  if (!event.reason) return;
  const chunkFailedMessage = /Loading chunk .+ failed/;
  const hasAlreadyReloaded = window.location.hash === '#retry';
  if (chunkFailedMessage.test(event.reason) && !hasAlreadyReloaded) {
    window.location.hash = 'retry';
    window.location.reload(true);
  }
});
